import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { callVerifyPurchase, getImageWithAuth } from "../../../../apiCalls";
import { useUserContext } from "src/components/ProtectedRoute/userProvider";
import { MapComponent } from "./map";
import { Button, Container, Grid, Link } from "@mui/material";
import { Paper, Typography } from "@mui/material";
import { Box } from "@mui/material";
import FeedbackIcon from '@mui/icons-material/Feedback';
import logger from 'src/logger';
export const PaidForContent = () => {
  const [status, setStatus] = useState(null);
  const [coords, setCoords] = useState({ latitude: 0, longitude: 0 });
  const [image, setImage] = useState(null);
  const [error, setError] = useState('');
  const [buyerEmail, setBuyerEmail] = useState(null);

  useEffect(() => {
    logger.info('Returning to image view');

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get('session_id');
    const connectedAccountId = urlParams.get('connectedAccountId');

    const verifyPurchase = async () => {
      try {

        const purchaseResponse = await callVerifyPurchase(sessionId, connectedAccountId);

        if (purchaseResponse.isPurchased) {
          setBuyerEmail(purchaseResponse.buyerEmail);
          const imageData = purchaseResponse.metadata;
          if (imageData) {
            setImage(imageData);
            setCoords({
              latitude: imageData.latitude,
              longitude: imageData.longitude
            });
          } else {
            throw new Error('Image data could not be retrieved.');
          }
        } else {
          throw new Error('Image purchase verification failed or not purchased.');
        }
      } catch (error) {
        logger.error('Error:', error.message);
        setError('Image purchase verification failed or not purchased. Please try again or contact support.');
      }
    };

    if (sessionId && connectedAccountId) {
      verifyPurchase();
    }
  }, []);

  if (error) {
    return <div style={{ color: 'red' }}>Error: {error}</div>;
  }

  if (!image) {
    return <div>Loading...</div>;
  }

  if (status === 'open') {
    return <Navigate to="/checkout" />;
  }

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <Paper elevation={3} sx={{ p: 1, mb: 2 }}>
        <Box component="section" id="success">
          <Typography variant="h4" gutterBottom>    
            Purchase Successful!
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            We appreciate your business! A confirmation email will be sent to{' '}
            <Link href={`mailto:${buyerEmail}`} color="primary">
              {buyerEmail}
            </Link>
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<FeedbackIcon />}
            onClick={() => window.location.href = '/feedback'}
            size="medium"
          >
            Provide Feedback
          </Button>
        </Box>
      </Paper>

      <Paper elevation={3} sx={{ p: 1, mb: 2 }}>
        <Typography variant="h5" gutterBottom>
          Location Details
        </Typography>
        <Grid container spacing={2} sx={{ mb: 1 }}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" color="text.secondary">
              Latitude
            </Typography>
            <Typography variant="h6">
              {coords.latitude.toFixed(6)}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" color="text.secondary">
              Longitude
            </Typography>
            <Typography variant="h6">
              {coords.longitude.toFixed(6)}
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={3} sx={{ p: 1 }}>
        <Typography variant="h5" gutterBottom>
          Map Location
        </Typography>
        <Box sx={{ height: 400, width: '100%', borderRadius: 1, overflow: 'hidden' }}>
          <MapComponent longitude={coords.longitude} latitude={coords.latitude} />
        </Box>
      </Paper>
    </Container>
  );
};
